'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';
import uiRouter from 'angular-ui-router';

export class NavbarComponent {
  constructor($scope, $state, $window, $cookies, authService){
    this.$state = $state;
    this.$window = $window;
    this.$cookies = $cookies;
    this.authService = authService;

    this.menu = [
      { title: 'Documentation', state: 'documentation.getting_started', id: 'docs-route', uris: ['/documentation'], show: () => true },
      { title: 'APIs', state: 'apis', id: 'api-route', uris: ['apis'], show: () => true },
      { title: 'Applications', state: 'apps', id: 'appilication-route', uris: ['/apps', '/editapp', '/application'], show: authService.isLoggedIn },
      { title: 'Monitoring', state: 'monitoring', id: 'monitoring-route', uris: ['/monitoring'], show: authService.isLoggedIn },
      { title: 'Support', state: 'support', id: 'support-route', uris: ['/support'], show: () => true },
    ];
  }

  
  isCollapsed = true;

  navigateToMenu = function(item){    
    this.$state.go(item.state);
  };

  gotoRoot = function(){
    this.$window.location.href = '/';
  };

  isItemSelected = function(item){
    const href = this.$window.location.href;
    return item.uris ? item.uris.find(x => href.indexOf(x) >= 0) : false;
  }

  openProfile = () => {
    this.$state.go('profile');
  };
}

NavbarComponent.$inject = ['$scope', '$state', '$window', '$cookies', 'authService'];

export default angular.module('directives.navbar', [])
  .component('navbar', {
    template: require('./navbar.html'),
    controller: NavbarComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js